import { selector } from 'recoil';
import { teamsState } from '../atoms/teamsState';
import { PlayerMap } from '../../types/player';
import { userConfigState } from '../atoms/userConfigState';


export const playerTeamDataSelector = selector({
  key: 'playerTeamData',
  get: ({ get }) => {

    const teams = get(teamsState);
    const userConfig = get(userConfigState);

    if (teams && userConfig) {

      const playerTeamData: PlayerMap = {};

      Object.keys(teams).forEach(teamId => {

        const team = teams[teamId];

        Object.keys(team.players).forEach(positionKey => {

          const playerList = team.players[positionKey];
          playerList.forEach(player => {

            if (!playerTeamData[player.id]) {
              playerTeamData[player.id] = {};
            }

            playerTeamData[player.id][teamId] = positionKey;
          });

        });

      });

      return playerTeamData;
    }

    return null;
  },
});
